module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("bcjbA"))).then(() => parcelRequire('dzI3V'));